module.exports = __webpack_public_path__ + "img/TCC-L1-Pagina7 A.89db3def.png";